// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs--1yFBx","card_tab_navs":"card_tab_navs--9vSlL"};